import { ValidationFunction } from '@/common/validation';

export const confirmPassword: ValidationFunction = (value, [target]) => {
	if (value === target) {
		return true;
	}

	return 'Passwords does not match';
};
